import { useEffect, useRef, useState } from 'react'

/**
 * @description A component-lifecycle-safe state that eventually flips back to false
 * Warning: Changing the `after` param will clear and restart timers
 */
function useTimeoutPoll(after: number, timeoutCallback?: () => void) {
  const switchState = useState<boolean>(false)
  const callbackRef = useRef<undefined | (() => void)>(timeoutCallback)
  useEffect(() => {
    callbackRef.current = timeoutCallback
  }, [timeoutCallback])
  const [bit, setBit] = switchState
  useEffect(
    function closeSwitchAfterTimeout() {
      let timeoutId: undefined | number
      let localCallbackRef = callbackRef.current
      if (bit === true) {
        timeoutId = window.setTimeout(function stopPolling() {
          setBit(false)
          localCallbackRef?.()
        }, after)
      }
      return function cleanupEarlyCloseOrTimeoutChangeOrUnmount() {
        if (typeof timeoutId === 'number') {
          clearTimeout(timeoutId)
        }
      }
    },
    [bit, setBit, after, callbackRef]
  )

  return switchState
}

export default useTimeoutPoll
